import { Dialog, DialogContent } from '@material-ui/core';
import PropTypes from 'prop-types';

import { ChannelIcon } from 'src/components/ChannelIcon';
import { CUSTOM_BUTTON_SIZE, CustomButton } from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { getChannelPerformanceLabel } from 'src/data/channel';
import { getResourceDocumentLabel } from 'src/data/performance';

import celebration from './assets/celebration.svg';
import { useStyles } from './useStyles';

export const AccountsDataExtractionPopup = ({ open, onClose, account }) => {
  const styles = useStyles();

  return (
    <Dialog
      classes={{
        paper: styles.root,
      }}
      open={open}
      onClose={onClose}
      data-testid="AccountsDataExtractionPopup"
    >
      <DialogContent className={styles.dialogContent}>
        <div className={styles.celebration}>
          <img src={celebration} />
          <ChannelIcon
            channel={account.channel}
            className={styles.channelIcon}
          />
        </div>

        <CustomTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.semiBold16}
        >
          Successfully connected!
        </CustomTypography>
        <CustomTypography
          className={styles.accountDetails}
          variant={TYPOGRAPHY_VARIANT.paragraph16}
        >
          <span>Integration: </span>
          <span>
            {getChannelPerformanceLabel(account.channel) ||
              getResourceDocumentLabel(account.channel)}
          </span>
          <br />
          Name: {account.name}
        </CustomTypography>
        <CustomButton
          size={CUSTOM_BUTTON_SIZE.large}
          onClick={onClose}
        >
          Done
        </CustomButton>
      </DialogContent>
    </Dialog>
  );
};

AccountsDataExtractionPopup.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
AccountsDataExtractionPopup.defaultProps = {};
